var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.webImage || _vm.mobileImage)?_c('div',{staticClass:"app-banner-top",class:[_vm.big ? 'big' : null, _vm.small ? 'small' : null]},[_c('div',{class:[
				'banner-top-height',
				_vm.big ? 'big' : null, _vm.small ? 'small' : null ]},[_c('picture',[_c('source',{attrs:{"srcset":_vm.webImage,"media":"(min-width: 600px)"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.mobileImage,"alt":""}})]),_vm._v(" "),(_vm.small)?_c('button',{staticClass:"btn-more"},[_vm._v("Ver más")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d8b6c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/app-banner-top.vue
// module id = 846
// module chunks = 0 1 9 29